import type { Tenant } from '../lib/database.types';
import { resolveTrustItems } from '../lib/trust';

/**
 * Bande « 3 atouts / réassurance » — portée du legacy Food Kourt / Big Burger (parité C3).
 * Affichée entre le hero et les best-sellers. Pilotée par le tenant (délai dynamique +
 * libellés surchargés via `trust_items`), sinon 3 atouts génériques. Logique dans lib/trust.ts.
 */
export default function TrustBand({ tenant }: { tenant: Tenant }) {
  const items = resolveTrustItems(tenant);
  if (items.length === 0) return null;

  return (
    <section className="border-b border-black/5 bg-white">
      <div className="mx-auto grid max-w-7xl gap-4 px-4 py-8 sm:grid-cols-3 lg:px-6 lg:py-10">
        {items.map((it, i) => (
          <div key={i} className="flex items-start gap-3">
            <div
              className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl text-xl"
              style={{ background: 'var(--brand-light)', color: 'var(--brand-primary)' }}
            >
              <span aria-hidden>{it.icon}</span>
            </div>
            <div>
              <p className="font-bold leading-tight text-slate-900">{it.title}</p>
              <p className="text-sm leading-snug text-slate-500">{it.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
